import React, { useEffect, useState } from "react";
import FooterNew from "../components/Footer-New";
import Navbar from "../components/Navbar.js";

// import api
import { getCMSPage } from "../api/users.js";
import { getLang } from "../lib/localStorage.js";
import NavbarNew from "../components/Navbar-New.js";



export default function RiskDisclosure(props) {
  const [content, setContent] = useState("");
  let langCode = getLang();

  // function
  const fetchCmsPage = async () => {
    try {
      const { status, result } = await getCMSPage({
        identifier: "privacy_policy",
        langCode,
      });
      // console.log("result", result);
      if (status == "success") {
        setContent(result);
        // console.log("content", content);
        document.title = "risk-disclosure";
        const el = document.querySelector("meta[name='description']");
        el.setAttribute("content", result.metadescription);
        document.keywords = el;
        // console.log("el", el);
        const els = document.querySelector("meta[name='keywords']");
        els.setAttribute("content", result.metakeywords);
        document.description = els;
        // console.log("", els);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchCmsPage();
  }, []);

  return (
    <div>
     
      <NavbarNew />
      <div className="innerpages_wrapper">
        <div className="container">
          <div className="dash_wrapper terms_content">
            <div className="row">
              <div className="col-xl-12">
                <h1>Risk Disclosure</h1>
                <h4 className="mt-5 mb-2">Important Information</h4>
                <p>
                  The information contained on this website is provided by{" "}
                  <b>MG Asset Management</b> (“the Firm”, “we”, “our”, or “us”)
                  for general informational purposes only. It is not intended as
                  investment, legal, tax, accounting, or other professional
                  advice, nor should it be relied upon as the basis for any
                  investment decision.
                </p>
                <p>
                  Any references to investment strategies, asset classes, market
                  opportunities, or financial products are illustrative in
                  nature and may not be suitable for all investors. Prospective
                  clients should seek independent professional advice and
                  carefully consider their objectives, financial circumstances,
                  risk tolerance, liquidity needs, and investment horizon before
                  making any investment decision.
                </p>
                <h4 className="mt-5 mb-2">No Guarantee of Performance</h4>
                <p>
                  All investments involve risk, including the possible loss of
                  principal. Past performance is not indicative of future
                  results, and no assurance can be given that any investment
                  objective, return target, portfolio strategy, or capital
                  preservation goal will be achieved.
                </p>
                <p>
                  Market conditions, economic developments, interest rate
                  changes, inflation, geopolitical events, regulatory
                  developments, and other factors may materially affect the
                  value and performance of investments.
                </p>
                <p>
                  Any projected returns, illustrative scenarios, forecasts, or
                  expected outcomes presented on this website are hypothetical
                  in nature, subject to change, and should not be relied upon as
                  guarantees of future performance.
                </p>
                <h4 className="mt-5 mb-2">Market Risk</h4>
                <p>
                  The value of securities and other financial instruments may
                  fluctuate significantly due to market movements. Equity
                  markets, fixed income markets, credit markets, currencies,
                  commodities, and alternative investments may be affected by
                  volatility, changing investor sentiment, economic data,
                  monetary policy decisions, and global events.
                </p>
                <p>
                  Periods of market stress may result in rapid declines in asset
                  values, reduced liquidity, wider bid-offer spreads, and
                  increased correlation across asset classes.
                </p>
                <h4 className="mt-5 mb-2">Interest Rate and Inflation Risk</h4>
                <p>
                  Changes in prevailing interest rates may adversely affect the
                  value of fixed income securities, bonds, credit instruments,
                  real estate assets, and income-focused portfolios. Rising
                  interest rates may reduce market values of existing securities
                  and increase financing costs.
                </p>
                <p>
                  Inflation may erode purchasing power and reduce the real value
                  of portfolio returns over time. There can be no assurance that
                  investment returns will exceed inflation.
                </p>
                <h4 className="mt-5 mb-2">Credit and Counterparty Risk</h4>
                <p>
                  Investments in debt instruments, structured credit,
                  mortgage-related assets, private lending, and other
                  credit-sensitive strategies are subject to the risk that
                  issuers, borrowers, guarantors, or counterparties may fail to
                  meet their obligations in whole or in part.
                </p>
                <p>
                  Counterparty defaults, downgrades, restructuring events, or
                  deterioration in creditworthiness may materially impact
                  valuation, income generation, and liquidity.
                </p>
                <h4 className="mt-5 mb-2">Liquidity Risk</h4>
                <p>
                  Certain investments may not be readily marketable or may only
                  be realizable at a discount to carrying value. During adverse
                  market conditions, liquidity may diminish substantially,
                  making it difficult to sell or redeem investments at desired
                  times or prices.
                </p>
                <p>
                  Private market investments, real estate assets, structured
                  products, hedge strategies, and certain credit instruments may
                  be subject to lock-up periods, redemption restrictions, notice
                  periods, gates, or delayed distributions.
                </p>
                <h4 className="mt-5 mb-2">Alternative Investments Risk</h4>
                <p>
                  Alternative investments, including hedge fund strategies,
                  private equity, private debt, real estate structures,
                  structured credit, and other non-traditional investments,
                  involve a higher degree of complexity and may carry additional
                  risks beyond those associated with traditional asset classes.
                </p>
                <p>These risks may include:</p>
                <ul className="list-disc list-inside pl-5">
                  <li>Use of leverage</li>
                  <li>Concentrated exposures</li>
                  <li>Limited transparency</li>
                  <li>Reduced liquidity</li>
                  <li>Valuation uncertainty</li>
                  <li>Operational risk</li>
                  <li>Manager risk</li>
                  <li>Strategy-specific volatility</li>
                  <li>Longer investment horizons</li>
                  <li>Greater sensitivity to market dislocation</li>
                </ul>
                <p>
                  Alternative investments may be suitable only for sophisticated
                  or qualified investors capable of bearing substantial risk,
                  including total loss of invested capital.
                </p>
                <h4 className="mt-5 mb-2">Hedge Fund Strategies Risk</h4>
                <p>
                  Hedge-oriented strategies may employ short selling,
                  derivatives, leverage, concentrated positions, tactical
                  allocation, and non-directional market exposures. Such
                  strategies may be volatile and can generate losses in both
                  rising and falling markets.
                </p>
                <p>
                  There is no assurance that hedging techniques will be
                  effective or that downside protection objectives will be
                  achieved.
                </p>
                <h4 className="mt-5 mb-2">Real Estate Risk</h4>
                <p>
                  Real estate investments are subject to risks including
                  declines in property values, vacancy levels, tenant defaults,
                  financing availability, rising interest rates, construction
                  costs, environmental liabilities, regulatory changes,
                  taxation, and local market conditions.
                </p>
                <p>
                  Real estate investments may be illiquid and may require
                  significant time to realize value.
                </p>
                <h4 className="mt-5 mb-2">Mortgage-Backed and Structured Credit Risk</h4>
                <p>
                  Mortgage-related investments and structured credit instruments
                  are subject to prepayment risk, extension risk, default risk,
                  collateral deterioration, refinancing risk, valuation
                  complexity, and changing interest rate conditions.
                </p>
                <p>
                  Performance of such investments may be materially affected by
                  borrower behavior, housing market conditions, underwriting
                  quality, and macroeconomic developments.
                </p>
                <h4 className="mt-5 mb-2">Currency and International Investment Risk</h4>
                <p>
                  Investments denominated in foreign currencies or involving
                  international markets may be affected by exchange rate
                  fluctuations, political instability, changes in law or
                  taxation, market access restrictions, differing accounting
                  standards, and sovereign risk.
                </p>
                <p>
                  Emerging markets may present elevated volatility, weaker legal
                  protections, reduced liquidity, and heightened operational
                  risk.
                </p>
                <h4 className="mt-5 mb-2">Concentration Risk</h4>
                <p>
                  Portfolios concentrated in specific issuers, sectors,
                  geographic regions, strategies, or asset classes may be more
                  volatile and subject to greater losses than diversified
                  portfolios.
                </p>
                <p>
                  Diversification does not guarantee profit or protect against
                  loss.
                </p>
                <h4 className="mt-5 mb-2">Leverage Risk</h4>
                <p>
                  Certain investment strategies may utilize leverage through
                  borrowing, derivatives, or structured exposures. Leverage can
                  magnify gains and losses and may increase portfolio
                  volatility, margin requirements, refinancing risk, and the
                  possibility of forced liquidation during adverse market
                  movements.
                </p>
                <h4 className="mt-5 mb-2">Operational and Technology Risk</h4>
                <p>
                  Investment operations rely on internal processes, third-party
                  administrators, custodians, brokers, technology systems,
                  cybersecurity measures, and external service providers.
                </p>
                <p>
                  Failures, errors, fraud, cyber incidents, business
                  interruptions, data breaches, valuation errors, or systems
                  outages may adversely affect operations, reporting, or
                  investment outcomes.
                </p>
                <h4 className="mt-5 mb-2">Regulatory and Tax Risk</h4>
                <p>
                  Changes in applicable laws, regulations, tax treatment,
                  reporting obligations, or regulatory interpretations may
                  affect investment structures, returns, transaction costs, or
                  the suitability of certain strategies.
                </p>
                <p>
                  Tax outcomes depend on individual circumstances and may change
                  over time. Clients should seek independent tax advice.
                </p>
                <h4 className="mt-5 mb-2">Suitability and Client Responsibility</h4>
                <p>
                  Investment services and strategies referenced on this website
                  may not be suitable for all investors. Each client is
                  responsible for assessing whether any strategy or investment
                  is appropriate in light of their own financial objectives,
                  resources, experience, risk tolerance, and liquidity
                  requirements.
                </p>
                <p>
                  MG Asset Management may request information necessary to
                  assess suitability, but clients remain responsible for the
                  completeness and accuracy of information provided.
                </p>
                <h4 className="mt-5 mb-2">Forward-Looking Statements</h4>
                <p>
                  This website may contain statements regarding market
                  expectations, economic conditions, strategic outlooks, or
                  anticipated opportunities. Such statements are inherently
                  uncertain and based on assumptions that may prove inaccurate.
                </p>
                <p>
                  Actual outcomes may differ materially from any forward-looking
                  statement.
                </p>
                <h4 className="mt-5 mb-2">Website Content and Reliance</h4>
                <p>
                  While reasonable care may be taken in preparing website
                  content, MG Asset Management makes no representation or
                  warranty, express or implied, regarding the accuracy,
                  completeness, timeliness, or reliability of any information
                  contained herein.
                </p>
                <p>
                  Information may be updated, revised, or withdrawn without
                  notice.
                </p>
                <h4 className="mt-5 mb-2">No Offer or Solicitation</h4>
                <p>
                  Nothing on this website constitutes an offer to sell, a
                  solicitation to buy, or a recommendation regarding any
                  security, investment product, or managed account in any
                  jurisdiction where such offer or solicitation would be
                  unlawful.
                </p>
                <p>
                  Services may be subject to eligibility requirements,
                  regulatory restrictions, and onboarding procedures.
                </p>
                <h4 className="mt-5 mb-2">Contact</h4>
                <p>
                  If you require additional information regarding investment
                  risks, service suitability, or applicable disclosures, please
                  contact MG Asset Management directly through the contact
                  methods listed on this website.
                </p>
                <h4 className="mt-5 mb-2">Final Notice</h4>
                <p>
                  By using this website, you acknowledge that you understand
                  investments involve risk, values may fluctuate, income is not
                  guaranteed, and losses may exceed expectations depending on
                  strategy and market conditions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterNew/>
    </div>
  );
}
